import React from 'react';
import { TextField } from '@material-ui/core';
import styled from 'styled-components';

const EditableField = ({ label, value, onChange, onSubmit, persist = false, ...props }) => {
  return (
    <Box>
      <Input
        label={label}
        onChange={(e) => onChange(e.target.value)}
        value={value}
        placeholder={value}
        {...props}
      />
    </Box>
  );
};

const Box = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
`;

const Input = styled(TextField)`
  && {
    width: 100%;
    padding-bottom: 20px;
    input, textarea {
      padding: 8px;
      cursor: default;

      &:focus {
        cursor: text;
      }
    }
  }
`;

export default EditableField;
